 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import EBB from '@/components/ebb'
 import TLU from '@/components/tlu'
 import PORT from '@/components/port'
 import LOVE_1 from '@/components/love_1'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import EDITORNOTE from '@/components/Editor-Note'
 import BOOK1COVER from '@/components/Book1/cover'
 import BOOK1SECTION1 from '@/components/Book1/section1'
 import BOOK1SECTION2 from '@/components/Book1/section2'
 import BOOK1SECTION3 from '@/components/Book1/section3'
 import BOOK1SECTION4 from '@/components/Book1/section4'
 import BOOK1SECTION5 from '@/components/Book1/section5'
 import BOOK1SECTION6 from '@/components/Book1/section6'
 import BOOK1SECTION7 from '@/components/Book1/section7'
 import BOOK1SECTION8 from '@/components/Book1/section8'
 import BOOK1SECTION9 from '@/components/Book1/section9'
 import BOOK1SECTION10 from '@/components/Book1/section10'
 import BOOK1SECTION11 from '@/components/Book1/section11'
 import BOOK1SECTION12 from '@/components/Book1/section12'
 import BOOK1SECTION13 from '@/components/Book1/section13'
 import BOOK1SECTION14 from '@/components/Book1/section14'
 import BOOK1SECTION15 from '@/components/Book1/section15'
 import BOOK1SECTION16 from '@/components/Book1/section16'
 import BOOK1SECTION17 from '@/components/Book1/section17'
 import BOOK1SECTION18 from '@/components/Book1/section18'
 import BOOK1SECTION19 from '@/components/Book1/section19'
 import BOOK1SECTION20 from '@/components/Book1/section20'
 import BOOK1SECTION21 from '@/components/Book1/section21'
 import BOOK21COVER from '@/components/Book2/1-cover'
 import BOOK22TITLE_PAGE from '@/components/Book2/2-title_page'
 import BOOK23EPIGRAPH1 from '@/components/Book2/3-epigraph1'
 import BOOK24TOC from '@/components/Book2/4-TOC'
 import BOOK25START from '@/components/Book2/5-start'
 import BOOK26PART from '@/components/Book2/6-part'
 import BOOK27CHAP1 from '@/components/Book2/7-chap1'
 import BOOK28CHAP2 from '@/components/Book2/8-chap2'
 import BOOK29CHAP3 from '@/components/Book2/9-chap3'
 import BOOK210CHAP4 from '@/components/Book2/10-chap4'
 import BOOK211CHAP5 from '@/components/Book2/11-chap5'
 import BOOK212CHAP6 from '@/components/Book2/12-chap6'
 import BOOK213CHAP7 from '@/components/Book2/13-chap7'
 import BOOK214CHAP8 from '@/components/Book2/14-chap8'
 import BOOK215CHAP9 from '@/components/Book2/15-chap9'
 import BOOK216CHAP10 from '@/components/Book2/16-chap10'
 import BOOK217CHAP11 from '@/components/Book2/17-chap11'
 import BOOK218CHAP12 from '@/components/Book2/18-chap12'
 import BOOK219CHAP13 from '@/components/Book2/19-chap13'
 import BOOK220CHAP14 from '@/components/Book2/20-chap14'
 import BOOK221CHAP15 from '@/components/Book2/21-chap15'
 import BOOK222CHAP16 from '@/components/Book2/22-chap16'
 import BOOK223CHAP17 from '@/components/Book2/23-chap17'
 import BOOK224CHAP18 from '@/components/Book2/24-chap18'
 import BOOK225CHAP19 from '@/components/Book2/25-chap19'
 import BOOK226CHAP20 from '@/components/Book2/26-chap20'
 import BOOK227CHAP21 from '@/components/Book2/27-chap21'
 import BOOK228CHAP22 from '@/components/Book2/28-chap22'
 import BOOK229CHAP23 from '@/components/Book2/29-chap23'
 import BOOK230CHAP24 from '@/components/Book2/30-chap24'
 import BOOK231CHAP25 from '@/components/Book2/31-chap25'
 import BOOK232CHAP26 from '@/components/Book2/32-chap26'
 import BOOK233CHAP27 from '@/components/Book2/33-chap27'
 import BOOK234CHAP28 from '@/components/Book2/34-chap28'
 import BOOK235CHAP29 from '@/components/Book2/35-chap29'
 import BOOK236CHAP30 from '@/components/Book2/36-chap30'
 import BOOK237CHAP31 from '@/components/Book2/37-chap31'
 import BOOK3XHTMLCOVER from '@/components/Book3/xhtml/cover'
 import BOOK3XHTMLPRAISE from '@/components/Book3/xhtml/praise'
 import BOOK3XHTMLTITLE from '@/components/Book3/xhtml/title'
 import BOOK3XHTMLDEDICATION from '@/components/Book3/xhtml/dedication'
 import BOOK3XHTMLCHAPTER001 from '@/components/Book3/xhtml/chapter001'
 import BOOK3XHTMLCHAPTER002 from '@/components/Book3/xhtml/chapter002'
 import BOOK3XHTMLCHAPTER003 from '@/components/Book3/xhtml/chapter003'
 import BOOK3XHTMLCHAPTER004 from '@/components/Book3/xhtml/chapter004'
 import BOOK3XHTMLCHAPTER005 from '@/components/Book3/xhtml/chapter005'
 import BOOK3XHTMLCHAPTER006 from '@/components/Book3/xhtml/chapter006'
 import BOOK3XHTMLCHAPTER007 from '@/components/Book3/xhtml/chapter007'
 import BOOK3XHTMLCHAPTER008 from '@/components/Book3/xhtml/chapter008'
 import BOOK3XHTMLCHAPTER009 from '@/components/Book3/xhtml/chapter009'
 import BOOK3XHTMLCHAPTER010 from '@/components/Book3/xhtml/chapter010'
 import BOOK3XHTMLCHAPTER011 from '@/components/Book3/xhtml/chapter011'
 import BOOK3XHTMLCHAPTER012 from '@/components/Book3/xhtml/chapter012'
 import BOOK3XHTMLCHAPTER013 from '@/components/Book3/xhtml/chapter013'
 import BOOK3XHTMLCHAPTER014 from '@/components/Book3/xhtml/chapter014'
 import BOOK3XHTMLCHAPTER015 from '@/components/Book3/xhtml/chapter015'
 import BOOK3XHTMLCHAPTER016 from '@/components/Book3/xhtml/chapter016'
 import LOVE_2 from '@/components/love_2'
 import COMONAUTHOR from '@/components/Comon/author'
 import COMONCOPYRIGHT from '@/components/Comon/copyright'
 import BOOK2BACKEDBACKAD_1 from '@/components/Book2/Backed/backad_1'
 import BOOK3BACKEDBACKAD_1 from '@/components/Book3/Backed/backad_1'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Editor-Note",
 			"name" : "Editor-Note",
 			"component" : EDITORNOTE
 		},
 		{
 			"path" : "/Book1/cover",
 			"name" : "Book1/cover",
 			"component" : BOOK1COVER
 		},
 		{
 			"path" : "/Book1/section1",
 			"name" : "Book1/section1",
 			"component" : BOOK1SECTION1
 		},
 		{
 			"path" : "/Book1/section2",
 			"name" : "Book1/section2",
 			"component" : BOOK1SECTION2
 		},
 		{
 			"path" : "/Book1/section3",
 			"name" : "Book1/section3",
 			"component" : BOOK1SECTION3
 		},
 		{
 			"path" : "/Book1/section4",
 			"name" : "Book1/section4",
 			"component" : BOOK1SECTION4
 		},
 		{
 			"path" : "/Book1/section5",
 			"name" : "Book1/section5",
 			"component" : BOOK1SECTION5
 		},
 		{
 			"path" : "/Book1/section6",
 			"name" : "Book1/section6",
 			"component" : BOOK1SECTION6
 		},
 		{
 			"path" : "/Book1/section7",
 			"name" : "Book1/section7",
 			"component" : BOOK1SECTION7
 		},
 		{
 			"path" : "/Book1/section8",
 			"name" : "Book1/section8",
 			"component" : BOOK1SECTION8
 		},
 		{
 			"path" : "/Book1/section9",
 			"name" : "Book1/section9",
 			"component" : BOOK1SECTION9
 		},
 		{
 			"path" : "/Book1/section10",
 			"name" : "Book1/section10",
 			"component" : BOOK1SECTION10
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js